var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React, { Component } from 'react';
import styled from 'styled-components';
import { isValid, color } from '../../utils';
import Label from '../Label';
import { theme } from '../../styled';
const cautionIcon = (_a = require('./svg/icon_caution.svg')) === null || _a === void 0 ? void 0 : _a.default;
export const paddingRight = (props) => {
    if (props.password) {
        if (props.state === 'invalid')
            return '60px';
        return '40px';
    }
    if (props.state === 'invalid')
        return '30px';
    return '10px';
};
export const InputComponentWrapper = styled.div `
  .label-wrapper {
    text-align: ${(props) => (props.topLabel ? 'left' : 'right')};
    /* margin: ${(props) => props.topLabelAlign === 'left' ? 'inherit' : 'auto'}; */
    margin-bottom: ${(props) => (props.topLabel ? '0.5rem' : '0')};
  }
`;
export const InputContainer = styled.div `
  flex-direction: column;

  @media ${theme.md} {
    flex-direction: inherit;
  }
`;
export const InputBox = styled.div `
  position: relative;
`;
export const InputStyle = styled.input `
  display: ${(props) => (props.fullSize ? 'none' : 'block')};
  padding: 10px;
  padding-right: ${(props) => paddingRight(props)};
  margin-left: ${(props) => props.labelGridCol == 0 || props.topLabel ? '0' : '10px'};
  width: ${(props) => props.labelGridCol == 0 || props.labelGridCol == 12
    ? '100%'
    : 'calc(100% - 10px)'};
  border-radius: 2px;
  font-size: ${(props) => props.theme.fontMedium};
  line-height: 1rem;
  color: ${(props) => props.theme.navyBlue};
  outline: none;
  box-sizing: border-box;
  background: ${(props) => props.background || props.theme.blackSqueeze};
  border: 1px solid ${(props) => color(props.state)};
  background-clip: padding-box;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  @media ${theme.md} {
    font-size: ${(props) => props.theme.fontSmall};
  }

  &:focus {
    border: 1px solid ${(props) => props.theme.blue};
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }
`;
export const Icon = styled.img `
  position: absolute;

  right: ${(props) => (props.offset ? props.offset + 10 : 10)}px;
  top: 10px;
  width: 16px;
  height: 16px;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'auto')};
`;
export const Error = styled.div `
  margin-top: 5px;
  margin-left: 10px;
  font-size: ${(props) => props.theme.fontXXSmall};
  line-height: 15px;
  color: ${(props) => props.theme.red};
`;
class InputComponent extends Component {
    constructor(props) {
        super(props);
        this.handlePasswordToggle = () => this.setState((_a) => {
            var { password } = _a, state = __rest(_a, ["password"]);
            return ({ password: !password });
        });
        this.state = {
            password: props.password,
        };
    }
    render() {
        const { hideValue, autofocus, label, pattern, password, name, style, disabled, input, onChange, onEnter, labelGridCol, topLabel, inputGridCol, offset, requiredStar, topLabelAlign, inputGridColMd, background, buttonComponent, formHelpers, } = this.props;
        const getGridCol = () => {
            if (inputGridCol) {
                return inputGridCol;
            }
            const grid = topLabel ? 12 : 12 - (labelGridCol || 3);
            return grid;
        };
        const showError = input && input.state === 'invalid';
        return (React.createElement(InputComponentWrapper, { className: "InputComponent row no-gutters", style: style, topLabelAlign: topLabelAlign, topLabel: topLabel },
            React.createElement(Label, { className: `col-${labelGridCol || 3} col`, requiredStar: !requiredStar, text: label }),
            React.createElement(InputContainer, { className: `InputBox d-flex col-${getGridCol()} col-md-${inputGridColMd || labelGridCol || 3}` },
                React.createElement(InputBox, { className: "d-flex w-100" },
                    React.createElement(InputStyle, Object.assign({ className: "styled-input", id: name, pattern: pattern, state: input && input.state, name: name, type: hideValue ? 'password' : 'text', labelGridCol: labelGridCol, required: true, password: password, disabled: disabled, topLabel: topLabel, background: background, autoFocus: autofocus || false, onKeyPress: (e) => {
                            if (!e) {
                                return null;
                            }
                            const charCode = e.charCode || e.keyCode;
                            return charCode === 13 && onEnter ? onEnter(e) : null;
                        }, onChange: ({ target }) => onChange(name, target.value, isValid(target.value, this.props.pattern)), value: input && input.value }, formHelpers)),
                    showError && (React.createElement(Icon, { left: true, offset: offset, src: cautionIcon, alt: "error" }))),
                buttonComponent),
            showError && (React.createElement(Error, { id: `error-${name}`, className: "error-msg" }, input.error))));
    }
}
InputComponent.defaultProps = {
    style: {},
    labelGridCol: 3,
    password: false,
    onChange: (_k, _v, _s) => { },
    topLabel: false,
};
export default InputComponent;
